import script from "./FormAgree.vue?vue&type=script&setup=true&lang=js"
export * from "./FormAgree.vue?vue&type=script&setup=true&lang=js"

import "./FormAgree.vue?vue&type=style&index=0&id=1ec2965f&lang=scss"

const __exports__ = script;

export default __exports__